var React = require('react');

function Dz (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M320 0h320v480H320z","key":0}),React.createElement("path",{"fill":"#006233","d":"M0 0h320v480H0z","key":1}),React.createElement("path",{"fill":"#d21034","d":"M424 180a120 120 0 1 0 0 120 96 96 0 1 1 0-120m4 60l-108-35.2 67.2 92V183.2l-67.2 92z","key":2})]);
}

Dz.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Dz;

Dz.default = Dz;
